import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { NebulaOverviewData } from '../../../../types/nebula-insights';
import { formatRelativeTime, formatUserName } from '../utils';

interface RecentActivityListProps {
  items: NebulaOverviewData['recentActivity'];
  onOpenConversation: (conversationId: string) => void;
}

const RecentActivityList: React.FC<RecentActivityListProps> = ({
  items,
  onOpenConversation,
}) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-5 h-full">
    <div className="mb-4">
      <h3 className="text-sm font-medium text-gray-900 font-family-messina-sans">
        Recent activity
      </h3>
      <p className="text-xs text-gray-500 font-family-messina-sans mt-1">
        Latest conversations across artists
      </p>
    </div>
    {items.length === 0 ? (
      <p className="text-sm text-gray-500 font-family-messina-sans py-6 text-center">
        No recent conversations
      </p>
    ) : (
      <div className="space-y-1">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => onOpenConversation(item.id)}
            className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 text-left transition-colors group"
          >
            <span className="w-2 h-2 rounded-full bg-gray-800 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-gray-900 font-family-messina-sans truncate group-hover:text-gray-700">
                {item.title || 'Untitled conversation'}
              </p>
              <p className="text-xs text-gray-500 font-family-messina-sans truncate">
                {item.artistName || formatUserName(item.user?.firstname, item.user?.lastname)}
                {' · '}
                {formatRelativeTime(item.lastActiveAt ?? item.updatedAt)}
              </p>
            </div>
            <ChevronRight size={16} className="text-gray-400 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
          </button>
        ))}
      </div>
    )}
  </div>
);

export default RecentActivityList;
